module.exports = __webpack_public_path__ + "static/media/oficio-website.4f80dad7.png";